import SplitButton from "./SplitButton";
import Link from "ui/components/Link";

## Basic Usage

export function BasicSplitButton() {
  return (
    <SplitButton
      innerEl="Save"
      onClick={() => alert("Save clicked!")}
      size="large"
      menuItems={[
        <Link key="1" onClick={() => alert("Save as draft")}>Save as draft</Link>,
        <Link key="2" onClick={() => alert("Save and close")}>Save and close</Link>,
        <Link key="3" onClick={() => alert("Save as template")}>Save as template</Link>,
      ]}
    />
  );
}

<BasicSplitButton />

---

## Sizes

export function SplitButtonSizes() {
  const menuItems = [
    <Link key="1" onClick={() => {}}>Option 1</Link>,
    <Link key="2" onClick={() => {}}>Option 2</Link>,
  ];
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
      <SplitButton innerEl="Small" onClick={() => {}} size="small" menuItems={menuItems} />
      <SplitButton innerEl="Medium" onClick={() => {}} size="medium" menuItems={menuItems} />
      <SplitButton innerEl="Large" onClick={() => {}} size="large" menuItems={menuItems} />
    </div>
  );
}

<SplitButtonSizes />

---

## Disabled State

export function DisabledSplitButton() {
  return (
    <SplitButton
      innerEl="Disabled"
      onClick={() => {}}
      size="large"
      disabled
      title="This action is not available"
      menuItems={[
        <Link key="1">Option 1</Link>,
        <Link key="2">Option 2</Link>,
      ]}
    />
  );
}

<DisabledSplitButton />

---

## Create Actions Example

export function CreateActions() {
  return (
    <SplitButton
      innerEl="Create"
      onClick={() => alert("Create new item")}
      size="large"
      menuItems={[
        <Link key="1" onClick={() => alert("Create folder")}>Create folder</Link>,
        <Link key="2" onClick={() => alert("Create document")}>Create document</Link>,
        <Link key="3" onClick={() => alert("Import file")}>Import from file</Link>,
      ]}
    />
  );
}

<CreateActions />

---

## Export Options Example

export function ExportOptions() {
  return (
    <SplitButton
      innerEl="Export"
      onClick={() => alert("Export as PDF")}
      size="medium"
      menuItems={[
        <Link key="1" onClick={() => alert("Export as CSV")}>Export as CSV</Link>,
        <Link key="2" onClick={() => alert("Export as Excel")}>Export as Excel</Link>,
        <Link key="3" onClick={() => alert("Export as JSON")}>Export as JSON</Link>,
      ]}
    />
  );
}

<ExportOptions />

---

## With Custom Content

export function CustomContent() {
  return (
    <SplitButton
      innerEl={<span style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>+ Add Item</span>}
      onClick={() => alert("Add item")}
      size="large"
      menuItems={[
        <Link key="1" onClick={() => {}}>Add multiple</Link>,
        <Link key="2" onClick={() => {}}>Add from template</Link>,
      ]}
    />
  );
}

<CustomContent />

